var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "location_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.18 21.68c.23.21.53.32.82.32v.01c.3 0 .59-.11.82-.32 1.01-.91 6.06-5.76 6.47-11.57.02-.26.04-.52.04-.79C19.33 5.29 16.04 2 12 2S4.67 5.29 4.67 9.33c0 .27.01.53.04.75.41 5.84 5.47 10.69 6.47 11.6M6.67 9.33C6.67 6.39 9.06 4 12 4s5.33 2.39 5.33 5.33c0 .161-.014.322-.031.508l-.01.102c-.31 4.39-3.87 8.35-5.29 9.76-1.42-1.41-4.99-5.37-5.3-9.8q-.03-.285-.03-.57M9 9.55c0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3-3 1.35-3 3m2 0c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1",
  clipRule: "evenodd"
})));
export default SvgLocation;